import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AllIconsComponent } from "../all-icons/all-icons.component";
import { NgClass } from "@angular/common";

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
  imports: [
    AllIconsComponent,
    FormsModule,
    NgClass,
  ],
  standalone: true,
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() disabled = false;
  @Input() checked = false;
  @Input() minus = false;
  @Input() isContentLeft = false;
  @Input() suffixImgAndStyling: string;
  @Input() bottomDescription: string;
  @Input() checkBoxStyle: string;

  @Output() checkBoxClicked: EventEmitter<boolean> = new EventEmitter<boolean>();


  onChange: any = () => {};
  onTouch: any = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(checked: boolean): void {
    this.checked = checked;
  }

  checkBoxEmitter(clicked: boolean): void {
    this.checkBoxClicked.emit(clicked);
  }

  /**
   * Write form disabled state to the DOM element (model => view)
   */
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(e: boolean): void {
    this.checked = e;
    this.onChange(e);
    this.checkBoxEmitter(e);
  }
}
